import { GenderStatusEnum } from '../types';

export const genderMapper = (gender: GenderStatusEnum | undefined) => {
  if (gender === GenderStatusEnum.Undefined) {
    return GenderStatusEnum.Unknown;
  }
  return gender || GenderStatusEnum.Unknown;
};
